import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tag from '@alifd/next/lib/tag';
import { Color, COLORED_CLASS_NAME, PROTECTED_TYPE } from './constants';

var ColoredTag = function ColoredTag(_ref) {
  var type = _ref.type,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["type", "className"]);

  return /*#__PURE__*/React.createElement(Tag, _extends({}, restProps, {
    className: classNames(COLORED_CLASS_NAME, "".concat(COLORED_CLASS_NAME, "-").concat(type), className)
  }));
};
/**
 * Prop types
 * @static
 * @type {Object}
 */


ColoredTag.propTypes = _objectSpread(_objectSpread({}, Tag.propTypes), {}, {
  // Specific color of tag
  type: PropTypes.oneOf(_Object$values(Color)),
  // Class name of tag
  className: PropTypes.string
});
/**
 * Default props
 * @static
 * @type {Object}
 */

ColoredTag.defaultProps = {
  type: Color.LIGHT_STEEL_BLUE
};
ColoredTag[PROTECTED_TYPE] = 'Tag';
export default ColoredTag;